'use es6';

const makeMessageKeyUtil = base => {
  return key => `account-and-billing-fintech-outages.${base}.${key}`;
};

export default makeMessageKeyUtil;